import type { AppThunk } from '~/@types/app-types';
import { signInActions, signOutActions } from './actions';
import { AuthApi } from '~/api/auth.api';
import { fakeUserData } from '~/mock/fakeUser';
import { errorHandler } from '~/store/utils/errorHendler';

export const signIn: AppThunk<{ email: string; password: string }> = p => async dispatch => {
    dispatch(signInActions.request(p));

    try {
        const data = await AuthApi.login(p);

        const result = {
            ...fakeUserData,
            name: data.firstName,
            fullName: data.firstName + ' ' + data.lastName,
            ...data,
        };

        dispatch(signInActions.success(result));
        return result;
    } catch (e) {
        dispatch(signInActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};

export const signOut: AppThunk = () => async dispatch => {
    dispatch(signOutActions.request());

    try {
        dispatch(signOutActions.success());
    } catch (e) {
        dispatch(signOutActions.failure({ error: e }));
    }
};
